import React from 'react';
import { useSnackbar } from 'notistack';
import { Button } from '@mui/material';
import EventTwoTone from '@mui/icons-material/EventTwoTone';
import { useAxios } from './util/use-axios';

const download = (fileName, text) => {
  var element = document.createElement('a');
  element.setAttribute(
    'href',
    'data:text/calendar;charset=utf-8,' + encodeURIComponent(text),
  );
  element.setAttribute('download', fileName);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
};

const AddToCalendar = ({ getPayload, fileName }) => {
  const { enqueueSnackbar } = useSnackbar();

  const { axiosHttp } = useAxios();

  const clickHandler = () => {
    const payload = getPayload();

    axiosHttp('/api/requests/add-to-calendar', {
      method: 'post',
      payload: payload || {},
    })
      .then((res) => {
        download(`${fileName}.ics`, res.data);

        const successMessage =
          res?.data?.message ??
          'Click on downloaded ics file to add event to your calendar';

        enqueueSnackbar(successMessage, { variant: 'success' });
      })
      .catch((err) => enqueueSnackbar(err.message, { variant: 'error' }));
  };

  return (
    <Button variant="contained" startIcon={<EventTwoTone />} onClick={clickHandler}>
      Add
    </Button>
  );
};

export { AddToCalendar };
